import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { useTranslation } from 'react-i18next'
import { updateTenant } from '../../api/tenant'

const cardStyle  = { background: 'white', border: '0.5px solid #e0e3f0', borderRadius: 12, padding: 18, marginBottom: 12 }
const inputStyle = { width: '100%', padding: '8px 12px', border: '0.5px solid #e0e3f0', borderRadius: 8, fontSize: 13, background: 'white', color: '#111', outline: 'none', boxSizing: 'border-box' }
const labelStyle = { fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4, display: 'block' }

export default function ChatStyle({ tenantId, bot, onUpdate }) {
  const { t } = useTranslation()
  const [form, setForm] = useState({
    bot_name:        bot?.bot_name        ?? '',
    welcome_message: bot?.welcome_message ?? '',
    cta_text:        bot?.cta_text        ?? '',
    primary_color:   bot?.primary_color   ?? '#1535c8',
    widget_position: bot?.widget_position ?? 'bottom-right',
  })
  const [saved, setSaved]   = useState(false)
  const [saving, setSaving] = useState(false)

  function set(key, val) { setForm(f => ({ ...f, [key]: val })); setSaved(false) }

  async function handleSave() {
    setSaving(true)
    try {
      await updateTenant(tenantId, form)
      setSaved(true)
      onUpdate()
    } catch (err) {
      Sentry.captureException(err, {
        tags: { action: 'save_chat_style' },
        extra: { tenantId },
      })
    }
    setSaving(false)
  }

  return (
    <div>
      <div style={cardStyle}>
        <label style={labelStyle}>{t('chatStyle.botName')}</label>
        <input style={inputStyle} value={form.bot_name} onChange={e => set('bot_name', e.target.value)} />
      </div>

      <div style={cardStyle}>
        <label style={labelStyle}>{t('chatStyle.welcome')}</label>
        <textarea rows={2} style={{ ...inputStyle, resize: 'vertical' }} value={form.welcome_message} onChange={e => set('welcome_message', e.target.value)} />
      </div>

      <div style={cardStyle}>
        <label style={labelStyle}>{t('chatStyle.cta')}</label>
        <input style={inputStyle} value={form.cta_text} onChange={e => set('cta_text', e.target.value)} placeholder={t('chatStyle.ctaPh')} />
      </div>

      <div style={cardStyle}>
        <label style={labelStyle}>{t('chatStyle.primaryColor')}</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <input type="color" value={form.primary_color} onChange={e => set('primary_color', e.target.value)}
            style={{ width: 36, height: 36, border: 'none', background: 'none', cursor: 'pointer', padding: 0, borderRadius: 6 }} />
          <input style={{ ...inputStyle, flex: 1, width: 'auto' }} value={form.primary_color} onChange={e => set('primary_color', e.target.value)} />
        </div>
      </div>

      <div style={cardStyle}>
        <label style={labelStyle}>{t('chatStyle.widgetPosition')}</label>
        <select style={inputStyle} value={form.widget_position} onChange={e => set('widget_position', e.target.value)}>
          <option value="bottom-right">{t('chatStyle.posBr')}</option>
          <option value="bottom-left">{t('chatStyle.posBl')}</option>
        </select>
      </div>

      <button onClick={handleSave} disabled={saving}
        style={{ background: saved ? '#16a34a' : '#1535c8', color: 'white', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
        {saving ? t('common.saving') : saved ? t('common.saved') : t('common.saveChanges')}
      </button>
    </div>
  )
}
